const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

export default [
  {
    title: 'How do you currently measure changes in user happiness? 🤔',
    answers: [
      { id: 1, text: '📝 Testimonials that we reach out to customers for' },
      {
        id: 2,
        text: '📞 Measure changes in the number of support tickets',
      },
      { id: 3, text: '🌡 NPS' },
      { id: 4, text: "🚫 I don't. I just measure user behaviour" },
    ],
    feedBack: {
      title: 'Cool!',
      emoji: '🙏',
      text: 'We appreciate your feedback.',
    },
  },

  {
    title: 'How are you feeling today? 😊',
    answers: [
      { id: 1, text: 'Ya ok.' },
      { id: 2, text: 'Fantastic!' },
      { id: 3, text: 'Best. Day. Ever!' },
    ],
    feedBack: {
      title: 'Us too.',
      text: `Cant beat a ${days[new Date().getDay()]}.`,
    },
  },

  {
    title: 'Why did you click that? 🤔',
    answers: [
      { id: 1, text: "I'm trying to find my settings" },
      { id: 2, text: "I'm trying to logout" },
      { id: 3, text: "I'm trying to change my profile picture" },
      { id: 4, text: 'None of the above' },
    ],
    feedBack: {
      title: 'Interesting.',
      emoji: '🤔',
      text: "Thanks! We're on it.",
    },
  },

  {
    title: 'Was this process confusing? 🤔',
    answers: [
      { id: 1, text: '😠 Yes, it was confusing.' },
      { id: 2, text: '😀 No! It was clear.' },
    ],
    feedBack: {
      title: 'Got it.',
      text: "Thanks for letting us know, we're always looking to improve!",
    },
  },

  {
    title: 'How often do you survey your customers? 🙋‍',
    answers: [
      { id: 1, text: 'Around once a week.' },
      { id: 2, text: 'Less than once a week.' },
      { id: 3, text: 'More than once a week.' },
      { id: 4, text: 'Never!' },
    ],
    feedBack: {
      title: 'Fascinating.',
      emoji: '😲',
      text: "We'll take that into account. Thanks for letting us know 👍",
    },
  },

  {
    title: 'How are you enjoying our demo? 👋',
    answers: [
      { id: 1, text: '😍 Love it.' },
      { id: 2, text: '😠 Hate it.' },
      { id: 3, text: "😕 It's ok." },
    ],
    feedBack: {
      title: 'I see.',
      emoji: '😲',
      text: "We're trying! ✌️",
    },
  },
]



// WEBPACK FOOTER //
// ../api/src/sampleQuestions.js